<template>
  <div class="login">
    <div class="container">
      <h1 class="display-1 primary--text my-3">Cadastro para acesso a Nota Fiscal Avulsa</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 lg4 xl3>
          <v-card hover class="ma-3">
            <v-card-title class="title">Cadastro Prestador de Serviços</v-card-title>
            <v-card-text>
              <h4 class="mt-3">Quem deve se cadastrar nesta opção:</h4>
              <div class="mt-2">
                <ol>
                  <li>Pessoa Física ou Jurídica prestadora de serviço, estabelecida em outro município.</li>
                  <li>Titular do imposto devido para o município.</li>
                  <li>Obrigado à emissão de NFSe-A.</li>
                </ol>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-btn block depressed color="primary" @click="cadastrarPrestador">
                <v-icon left>card_travel</v-icon>
                <span>Cadastro Prestador de Serviço</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 lg4 xl3>
          <v-card hover class="ma-3">
            <v-card-title class="title">Pessoa Física e Jurídica</v-card-title>
            <v-card-text>
              <h4 class="mt-3">Quem deve se cadastrar nesta opção:</h4>
              <div class="mt-2">
                <ul>
                  <li>Pessoa Física ou Jurídica não prestadora de serviço.</li>
                </ul>
                <p class="ml-4 mt-2">
                  <strong>Somente para a consulta de notas emitidas.</strong>
                </p>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-btn block depressed color="info"
                     v-on:click="abrePopUp()">
                <v-icon left>account_circle</v-icon>
                <span>Cadastrar como PF/PJ</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import {base_url} from "../global";

export default {
  data() {
    return {};
  },
  methods: {
    cadastrarPrestador() {
      window.location.replace(
        `${base_url}/notafiscal/paginas/contribuintefora/contribuinteForaList.jsf?incluir=S`
      );
    },
    abrePopUp() {
      window.open(this.getBaseUrl,'Pagina','resizable=0,WIDTH=1024, HEIGHT=640')
    }
  },
  computed: {
    getBaseUrl() {
      return `${base_url}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?mostraCampoMatricula=N&faces-redirect=true`;
    },
  },
};
</script>
